import React from 'react'
import PropTypes from 'prop-types'
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react'
import { cilArrowCircleLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useTranslation } from 'react-i18next'

const InternalAppHeader = ({ title, onBack }) => {
  const { t } = useTranslation()

  return (
    <CRow className="justify-content-center g-4">
      <CCol lg={10}>
        <CCard className="risk-notification-header-card border-0 shadow-sm">
          <CCardBody className="risk-notification-header-card__body">
            <div className="risk-notification-header-card__layout d-flex align-items-center gap-3 flex-wrap">
              <CButton
                color="primary"
                variant="outline"
                className="risk-notification-header-card__back"
                onClick={onBack}
                aria-label={t('navigation.back', 'Go back')}
              >
                <CIcon icon={cilArrowCircleLeft} size="lg" />
              </CButton>
              <div className="info-navbar__brand app-header__brand">
                <div className="info-navbar__brand-copy">
                  <h6 className="info-navbar__brand-title mb-0">{title}</h6>
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

InternalAppHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default InternalAppHeader
